import React, { useEffect, useState, useContext } from 'react'
import CustomImage from '../../components/customImage/customImage'
import useTemplateHook from '../../components/template/templateHook'
import { useTranslation } from 'react-i18next'
import useAxios from 'axios-hooks'
import { withTheme } from 'theming'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { useSearchParams } from 'react-router-dom'
import { AppContext } from '../../context/app'
import SocialAuth from '../../components/socialAuth'

const EclipseSignUpModal = (props) => {
  let { isEdit = false, theme, data, setModalState } = props

  const { t } = useTranslation()
  const { setModalType, accountObj } = useContext(AppContext)
  const isSocialLoginAllowed = accountObj?.od_resource_allowances?.is_social_login_allowed

  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [referralCode, setReferralCode] = useState('')
  const [searchParams] = useSearchParams()
  const code = searchParams.get('referral_code', '')

  const [errorData, setErrorData] = useState({})
  const [hoverState, setHoverState] = useState('')
  const [show, setShow] = useState(false)

  const {
    getTemplateImage,
    setLoader,
    setUser,
    LOGIN_API,
    SIGNUP_API,
    EditIcon,
    raiseToast,
    setOpenLoginModal,
  } = useTemplateHook()

  const [{ data: loginRes, loading: loginResLoading }, loginCall] = useAxios(
    {
      url: LOGIN_API,
      method: 'post',
    },
    { manual: true },
  )

  const [{ data: signUpRes, loading: signUpLoading }, signUpCall] = useAxios(
    {
      url: SIGNUP_API,
      method: 'post',
    },
    { manual: true },
  )

  // Show modal with delay on mount
  useEffect(() => {
    setTimeout(() => setShow(true), 10)
  }, [])

  useEffect(() => {
    if (loginRes && loginRes.success) {
      setUser(loginRes?.data, false, true)
      emptyState()
      handleClose()
    }
  }, [loginRes])

  useEffect(() => {
    if (signUpRes && signUpRes?.success) {
      raiseToast('success', t('register_success_toast'))
      loginCall({
        data: {
          email_id: email,
          password: password,
        },
      })
    }
  }, [signUpRes])

  useEffect(() => {
    setLoader(loginResLoading || signUpLoading)
  }, [loginResLoading, signUpLoading])

  useEffect(() => {
    if (code) {
      setReferralCode(code)
    }
  }, [code])

  const handleHoverItems = (name) => {
    if (!isEdit) return
    setHoverState(name)
  }

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (name.trim().length === 0) {
      isFormValid = false
      temp.name = `${t('user_name_empty')}!`
    }
    if (email.trim().length === 0) {
      isFormValid = false
      temp.email = `${t('email_empty')}!`
    }

    if (!email.includes('@') && email.trim().length !== 0) {
      isFormValid = false
      temp.email = `${t('invalid_email')}!`
    }

    if (password !== confirmPassword) {
      isFormValid = false
      temp.confirmPassword = `${t('passwords_match')}!`
    }
    if (password.trim().length === 0) {
      isFormValid = false
      temp.password = `${t('password_empty')}!`
    }
    if (confirmPassword.trim().length === 0) {
      isFormValid = false
      temp.confirmPassword = `${t('password_empty')}!`
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  const handleRegister = async () => {
    if (isEdit) return

    if (validateInfo()) {
      signUpCall({
        data: {
          email_id: email,
          password: password,
          name,
          phone,
          referral_code: referralCode,
        },
      })
    }
  }

  const handleChange = (event, func) => {
    const { value, name } = event.target

    if (errorData[`${name}`]) {
      delete errorData[`${name}`]
      setErrorData({ ...errorData })
    }
    func(value)
  }

  const handleClose = () => {
    setShow(false)
    setTimeout(() => {
      setOpenLoginModal(false)
    }, 400)
  }

  const emptyState = () => {
    setName('')
    setEmail('')
    setPhone('')
    setPassword('')
    setConfirmPassword('')
    setReferralCode('')
    setErrorData({})
  }

  const switchToLogin = () => {
    emptyState()
    setModalType('login')
  }

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!data?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = data?.style_config[parentKey]?.data.filter((info) => info.key === childKey)

    return tempArr && tempArr.length > 0
      ? tempArr[0].value
        ? tempArr[0].value
        : defaultValue
      : defaultValue
  }

  const handleModal = (modalData) => {
    setModalState({ ...modalData })
  }

  return (
    <div
      style={{
        backgroundColor: `${theme.c1}90`,
        opacity: show ? 1 : 0,
        transition: 'opacity 0.4s ease',
      }}
      className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
    >
      <div
        style={{
          transform: show ? 'scale(1)' : 'scale(0.9)',
          opacity: show ? 1 : 0,
          transition: 'all 0.4s ease',
        }}
        className="relative  my-6 w-11/12 md:w-10/12 lg:w-8/12 xl:w-5/12"
      >
        <div
          className={`${isEdit && hoverState && 'component-hover-class'} relative`}
          onMouseEnter={() => handleHoverItems(`TOP`)}
          onMouseLeave={() => handleHoverItems('')}
        >
          {isEdit && hoverState.length > 0 && (
            <div
              className="absolute h-[25px] w-[25px] rounded-full bg-[#2172eb] top-4 right-4 z-10 flex justify-center items-center cursor-pointer"
              onClick={() => handleModal({ modalKey: 'eclipseSignUpModal', data: data })}
            >
              <img src={EditIcon} className="w-[15px] h-[15px]" alt="edit icon" />
            </div>
          )}

          <div
            style={{
              background: getStyleValue('component_background', 'primary_color', theme.c10),
              boxShadow: '0 4px 20px 0 rgba(0, 0, 0, 0.8), 0 6px 20px 0 rgba(0, 0, 0, 0.80)',
            }}
            className="shadow-lg relative flex flex-col p-8"
          >
            {/* Close Button */}
            <div className="p-2 object-right-top absolute right-0 top-0">
              <button
                className="float-right m-4"
                onClick={() => {
                  handleClose()
                  emptyState('login')
                }}
              >
                <span
                  style={{ color: getStyleValue('signup_heading', 'color', theme.c5) }}
                  className=" h-6 w-6 text-2xl"
                >
                  ×
                </span>
              </button>
            </div>

            {/* Content */}
            <div className="w-full flex justify-center">
              <div className="w-[80%] md:w-[400px] xl:w-[500px] flex flex-col pb-10 xl:pb-0  items-center">
                {/* Logo */}
                <div
                  className={`w-full flex justify-center ${
                    isEdit && hoverState === 'IMAGE' && 'component-hover-class'
                  } relative`}
                  onMouseOver={() => handleHoverItems('IMAGE')}
                  onMouseLeave={() => handleHoverItems('TOP')}
                >
                  {hoverState === 'IMAGE' && (
                    <div
                      className="absolute h-[25px] w-[25px] rounded-full bg-[#2172eb] top-2 right-2 flex justify-center items-center cursor-pointer"
                      onClick={() =>
                        handleModal({
                          modalKey: 'logoModal',
                          data: data,
                          modalSpecificData: {
                            imgWidth: 255,
                            imgHeight: 101,
                            divWidth: '17.67rem',
                            divHeight: '7rem',
                          },
                        })
                      }
                    >
                      <img src={EditIcon} className="w-[15px] h-[15px]" alt="edit icon" />
                    </div>
                  )}
                  <CustomImage
                    imageUrl={getTemplateImage(data?.logo)}
                    imgClass="w-[146px] lg:w-[200px]"
                    loaderClass=""
                    imgAlt={'logo'}
                  />
                </div>

                {/* Sign Up Text */}
                <div
                  className={`w-full ${
                    isEdit && hoverState === 'SIGNUP_TEXT' && 'component-hover-class'
                  } ${isSocialLoginAllowed ? 'mt-3' : 'mt-5'} relative`}
                  onMouseOver={() => handleHoverItems('SIGNUP_TEXT')}
                  onMouseLeave={() => handleHoverItems('TOP')}
                >
                  {hoverState === 'SIGNUP_TEXT' && (
                    <div
                      className="absolute h-[25px] w-[25px] rounded-full bg-[#2172eb] top-2 right-2 flex justify-center items-center cursor-pointer"
                      onClick={() =>
                        handleModal({
                          modalKey: 'signupTextModal',
                          data: data,
                          modalSpecificData: {
                            stylesConfigArr: ['signup_heading', 'signup_description'],
                          },
                        })
                      }
                    >
                      <img src={EditIcon} className="w-[15px] h-[15px]" alt="edit icon" />
                    </div>
                  )}
                  <p
                    style={{
                      color: getStyleValue('signup_heading', 'color', theme.c5),
                      fontFamily: getStyleValue('signup_heading', 'font', ''),
                      textAlign: getStyleValue('signup_heading', 'alignment', 'center'),
                    }}
                    className={`mb-0 text-base lg:text-xl font-bold ${getStyleValue(
                      'signup_heading',
                      'font_format',
                      '',
                    )}`}
                  >
                    {data?.signup_text}
                  </p>
                  <p
                    style={{
                      color: getStyleValue('signup_description', 'color', theme.c3),
                      fontFamily: getStyleValue('signup_description', 'font', ''),
                      textAlign: getStyleValue('signup_description', 'alignment', 'center'),
                    }}
                    className={`mb-0 mt-3 text-xs ${getStyleValue(
                      'signup_description',
                      'font_format',
                      '',
                    )}`}
                  >
                    {data?.signup_description}
                  </p>
                </div>

                {/* Input Fields */}
                <div
                  className={`w-full ${
                    isEdit && hoverState === 'INPUT' && 'component-hover-class'
                  } mt-6 relative`}
                  onMouseOver={() => handleHoverItems('INPUT')}
                  onMouseLeave={() => handleHoverItems('TOP')}
                >
                  {hoverState === 'INPUT' && (
                    <div
                      className="absolute h-[25px] w-[25px] rounded-full bg-[#2172eb] top-2 right-2 flex justify-center items-center cursor-pointer"
                      onClick={() =>
                        handleModal({
                          modalKey: 'signupInputModal',
                          data: data,
                          modalSpecificData: {
                            stylesConfigArr: ['email_password_text', 'email_password_input'],
                          },
                        })
                      }
                    >
                      <img src={EditIcon} className="w-[15px] h-[15px]" alt="edit icon" />
                    </div>
                  )}

                  {/* Name Field */}
                  <div className={` ${isSocialLoginAllowed ? 'mb-2' : 'mb-4'}`}>
                    <p
                      style={{
                        color: getStyleValue('email_password_text', 'color', theme.c4),
                        fontFamily: getStyleValue('email_password_text', 'font', ''),
                        textAlign: getStyleValue('email_password_text', 'alignment', ''),
                      }}
                      className={`${getStyleValue(
                        'email_password_text',
                        'font_format',
                        '',
                      )} mb-0  text-xs lg:text-sm`}
                    >
                      {data?.name_text} <span className="text-red-600">*</span>
                    </p>
                    <input
                      type="text"
                      name="name"
                      value={name}
                      onChange={(e) => handleChange(e, setName)}
                      style={{
                        background: getStyleValue(
                          'email_password_input',
                          'background_color',
                          'transparent',
                        ),
                        color: getStyleValue('email_password_input', 'text_color', theme.c4),
                        border: `0.5px solid ${getStyleValue(
                          'email_password_input',
                          'border_color',
                          theme.c4,
                        )}`,
                      }}
                      className="text-xs lg:text-sm rounded block w-full p-1 mt-1 focus:outline-none"
                    />
                    {errorData?.name && (
                      <div className="error-message">
                        <p className="text-red-500 text-xs mt-1">{errorData.name}</p>
                      </div>
                    )}
                  </div>

                  {/* Email Field */}
                  <div className="mb-2">
                    <p
                      style={{
                        color: getStyleValue('email_password_text', 'color', theme.c4),
                        fontFamily: getStyleValue('email_password_text', 'font', ''),
                        textAlign: getStyleValue('email_password_text', 'alignment', ''),
                      }}
                      className={`${getStyleValue(
                        'email_password_text',
                        'font_format',
                        '',
                      )} mb-0  text-xs lg:text-sm`}
                    >
                      {data?.email_text} <span className="text-red-600">*</span>
                    </p>
                    <input
                      type="email"
                      name="email"
                      value={email}
                      onChange={(e) => handleChange(e, setEmail)}
                      style={{
                        background: getStyleValue(
                          'email_password_input',
                          'background_color',
                          'transparent',
                        ),
                        color: getStyleValue('email_password_input', 'text_color', theme.c4),
                        border: `0.5px solid ${getStyleValue(
                          'email_password_input',
                          'border_color',
                          theme.c4,
                        )}`,
                      }}
                      className=" text-xs lg:text-sm rounded block w-full p-1 mt-1 focus:outline-none"
                    />
                    {errorData?.email && (
                      <div className="error-message">
                        <p className="text-red-500 text-xs mt-1">{errorData.email}</p>
                      </div>
                    )}
                  </div>

                  {/* Phone Field */}
                  <div className="mb-2">
                    <p
                      style={{
                        color: getStyleValue('email_password_text', 'color', theme.c4),
                        fontFamily: getStyleValue('email_password_text', 'font', ''),
                        textAlign: getStyleValue('email_password_text', 'alignment', ''),
                      }}
                      className={`${getStyleValue(
                        'email_password_text',
                        'font_format',
                        '',
                      )} mb-0  text-xs lg:text-sm`}
                    >
                      {data?.phone}
                    </p>
                    <PhoneInput
                      country={'us'}
                      value={phone}
                      enableSearch={true}
                      onChange={(phone) => {
                        setPhone(phone)
                      }}
                      inputStyle={{
                        background: getStyleValue(
                          'email_password_input',
                          'background_color',
                          'transparent',
                        ),
                        color: getStyleValue('email_password_input', 'text_color', theme.c4),
                        border: `0.5px solid ${getStyleValue(
                          'email_password_input',
                          'border_color',
                          theme.c4,
                        )}`,
                        width: '100%',
                      }}
                    />
                  </div>

                  {/* Password Field */}
                  <div className="mb-2">
                    <p
                      style={{
                        color: getStyleValue('email_password_text', 'color', theme.c4),
                        fontFamily: getStyleValue('email_password_text', 'font', ''),
                        textAlign: getStyleValue('email_password_text', 'alignment', ''),
                      }}
                      className={`${getStyleValue(
                        'email_password_text',
                        'font_format',
                        '',
                      )} mb-0  text-xs lg:text-sm`}
                    >
                      {data?.password_text} <span className="text-red-600">*</span>
                    </p>
                    <input
                      type="password"
                      name="password"
                      value={password}
                      onChange={(e) => handleChange(e, setPassword)}
                      style={{
                        background: getStyleValue(
                          'email_password_input',
                          'background_color',
                          'transparent',
                        ),
                        color: getStyleValue('email_password_input', 'text_color', theme.c4),
                        border: `0.5px solid ${getStyleValue(
                          'email_password_input',
                          'border_color',
                          theme.c4,
                        )}`,
                      }}
                      className="text-xs lg:text-sm rounded block w-full p-1 mt-1 focus:outline-none"
                    />
                    {errorData?.password && (
                      <div className="error-message">
                        <p className="text-red-500 text-xs mt-1">{errorData.password}</p>
                      </div>
                    )}
                  </div>

                  {/* Confirm Password Field */}
                  <div className="mb-2">
                    <p
                      style={{
                        color: getStyleValue('email_password_text', 'color', theme.c4),
                        fontFamily: getStyleValue('email_password_text', 'font', ''),
                        textAlign: getStyleValue('email_password_text', 'alignment', ''),
                      }}
                      className={`${getStyleValue(
                        'email_password_text',
                        'font_format',
                        '',
                      )} mb-0  text-xs lg:text-sm`}
                    >
                      {data?.confirm_password_text} <span className="text-red-600">*</span>
                    </p>
                    <input
                      type="password"
                      name="confirmPassword"
                      value={confirmPassword}
                      onChange={(e) => handleChange(e, setConfirmPassword)}
                      style={{
                        background: getStyleValue(
                          'email_password_input',
                          'background_color',
                          'transparent',
                        ),
                        color: getStyleValue('email_password_input', 'text_color', theme.c4),
                        border: `0.5px solid ${getStyleValue(
                          'email_password_input',
                          'border_color',
                          theme.c4,
                        )}`,
                      }}
                      className="text-xs lg:text-sm rounded block w-full p-1 mt-1 focus:outline-none"
                    />
                    {errorData?.confirmPassword && (
                      <div className="error-message">
                        <p className="text-red-500 text-xs mt-1">{errorData.confirmPassword}</p>
                      </div>
                    )}
                  </div>

                  {/* Referral Code Field */}
                  <div className="mb-2">
                    <p
                      style={{
                        color: getStyleValue('email_password_text', 'color', theme.c4),
                        fontFamily: getStyleValue('email_password_text', 'font', ''),
                        textAlign: getStyleValue('email_password_text', 'alignment', ''),
                      }}
                      className={`${getStyleValue(
                        'email_password_text',
                        'font_format',
                        '',
                      )} mb-0  text-xs lg:text-sm`}
                    >
                      {data?.referral_code_text}
                    </p>
                    <input
                      type="text"
                      name="referralCode"
                      value={referralCode}
                      onChange={(e) => handleChange(e, setReferralCode)}
                      style={{
                        background: getStyleValue(
                          'email_password_input',
                          'background_color',
                          'transparent',
                        ),
                        color: getStyleValue('email_password_input', 'text_color', theme.c4),
                        border: `0.5px solid ${getStyleValue(
                          'email_password_input',
                          'border_color',
                          theme.c4,
                        )}`,
                      }}
                      className="text-xs lg:text-sm rounded block w-full p-1 mt-1 focus:outline-none"
                    />
                  </div>
                </div>

                {/* Button Section */}
                <div
                  className={`${isSocialLoginAllowed ? 'mt-3' : 'mt-6'} w-full text-center ${
                    isEdit && hoverState === 'BUTTON' && 'component-hover-class'
                  } relative`}
                  onMouseOver={() => handleHoverItems('BUTTON')}
                  onMouseLeave={() => handleHoverItems('TOP')}
                >
                  {hoverState === 'BUTTON' && (
                    <div
                      className="absolute h-[25px] w-[25px] rounded-full bg-[#2172eb] top-2 right-2 flex justify-center items-center cursor-pointer"
                      onClick={() =>
                        handleModal({
                          modalKey: 'signupButtonModal',
                          data: data,
                          modalSpecificData: {
                            stylesConfigArr: ['signup_button', 'account_text'],
                          },
                        })
                      }
                    >
                      <img src={EditIcon} className="w-[15px] h-[15px]" alt="edit icon" />
                    </div>
                  )}

                  <button
                    style={{
                      backgroundImage: `linear-gradient(to ${getStyleValue(
                        'signup_button',
                        'gradient',
                        'left',
                      )}, ${getStyleValue(
                        'signup_button',
                        'primary_color',
                        theme.c5,
                      )}, ${getStyleValue('signup_button', 'secondary_color', theme.c5)})`,
                      color: getStyleValue('signup_button', 'color', theme.c7),
                    }}
                    className="w-full py-2 rounded xl:text-base text-sm font-medium focus:outline-none"
                    onClick={handleRegister}
                  >
                    {data?.signup_button_text}
                  </button>

                  <p
                    className={`mb-0 mt-6 text-xs lg:text-sm ${getStyleValue(
                      'account_text',
                      'font_format',
                      '',
                    )}`}
                    style={{
                      color: getStyleValue('account_text', 'color', theme.c3),
                      fontFamily: getStyleValue('account_text', 'font', ''),
                      textAlign: getStyleValue('account_text', 'alignment', 'center'),
                    }}
                  >
                    {data?.account_text}{' '}
                    <span
                      className="font-semibold cursor-pointer"
                      style={{
                        color: getStyleValue('account_text', 'register_text_color', theme.c5),
                      }}
                      onClick={switchToLogin}
                    >
                      {data?.signin_text}
                    </span>
                  </p>
                </div>

                <div className="w-full">
                  <SocialAuth
                    textColor={getStyleValue('email_password_text', 'color', theme.c4)}
                    borderColor={getStyleValue('login_button', 'primary_color', theme.c5)}
                    isModal
                    signInText={'Or sign up with'}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withTheme(EclipseSignUpModal)
